<template>
    <section
        class="pc4-image-hero px-5 md:px-40 xl:px-80"
        :class="{'center-full' : centerFull}"
    >
        <div
            :style="`max-width: ${textMaxSize}`"
            class="animated ani-left-to-right"
            :class="{'center-full' : centerFull}"
        >
            <h1>
                <slot name="title" />
            </h1>
        </div>
        <p class="text-medium-size animated ani-bottom-to-top" :style="`max-width: ${textMaxSize}`">
            <slot name="description" />
        </p>
        <slot v-if="!noButton" name="button">
            <div
                class="animated ani-left-to-right-2 flex justify-center md:justify-start"
                :class="{'center-full' : centerFull }"
            >
                <ContactButton class="text-xl" />
            </div>
        </slot>
        <div class="down-arrow-hero hero-arrow">
            <a href="#intro">
                <svg class="w-7 h-5 md:w-10 md:h-7" viewBox="0 0 38 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.7"><path d="M37 1L19 21L1 1" stroke="url(#paint0_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M37 1L19 21L1 1" stroke="#78E270" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><linearGradient id="paint0_linear" x1="19" y1="1" x2="19" y2="21" gradientUnits="userSpaceOnUse"><stop stop-color="#137EC3"/><stop offset="1" stop-color="#F27330"/></linearGradient></defs></svg>
            </a>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ContactButton from '@/Components/Buttons/ContactButton.vue';

defineProps({
    noButton: {
        type: Boolean,
        required: false,
        default: false,
    },
    centerFull: {
        type: Boolean,
        required: false,
        default: false,
    },
    textMaxSize: {
        type: String,
        required: false,
        default: '550px',
    },
});

onMounted(() => {
    repeatAnimationOnView();
});

const observer = ref();

const repeatAnimationOnView = () => {
    const animatedElements = document.getElementsByClassName('animated')

    observer.value = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('ani');
                entry.target.classList.remove('opacity-0');
            } else {
                entry.target.classList.remove('ani');
                entry.target.classList.add('opacity-0');
            }
        });
    });
    Array.from(animatedElements).forEach(element => observer.value.observe(element));
}
/*
import ContactButton from "../../buttons/ContactButton.vue"
// import RepeatAnimationOnView from "@/components/utils/RepeatAnimationOnView.js"
export default {
  components:{
    ContactButton
  },
  props:{
    noButton:{
      type:Boolean,
      required:false,
      default:false,
    },
    centerFull:{
      type:Boolean,
      required:false,
      default:false,
    },
    textMaxSize:{
      type:String,
      required:false,
      default:'550px',
    },
  },
  computed:{
    currentRoute(){
      return this.$route.name;
    }
  },
  mounted(){
    this.repeatAnimationOnView();
  },
  methods:{
    repeatAnimationOnView(){

        const animatedElements = document.getElementsByClassName('animated')

        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('ani');
                    entry.target.classList.remove('opacity-0');
                } else {
                    entry.target.classList.remove('ani');
                    entry.target.classList.add('opacity-0');
                }
              });
        });
        Array.from(animatedElements).forEach( element => this.observer.observe(element));
    }
  }
}
*/
</script>

<style lang="postcss" scoped>
.center-full {
 @apply flex justify-center items-center;
}

.pc4-image-hero{
  background-size: cover;
  background-position: center;
  @apply flex flex-col justify-center h-screen text-white;
}

section {
  background:#2d2d2d;
  & > *{
    word-wrap:break-word;
  }
  & h1{
    @apply text-4xl md:text-6xl 2xl:text-7xl font-bold mb-5 uppercase;
  }

  & p{
    @apply mb-10;
  }
}
.down-arrow-hero{
  bottom: 20px;
  left: calc(50% - 20px);
  @apply absolute;
  a {
    @apply px-3;
  }

  @media (max-width: 768px) {
    bottom:15px;
  }
}

</style>

